define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class UserNetworkService
     */
    function UserNetworkService($root, $q, $log, $cookies, userNetworkProvider, localStorageService) {
        var self = this;
        var USER_NETWORK_KEY = 'user.userNetwork';
        var USER_NETWORK_KEY_EXPIRATION = 'user.userNetwork.expirationDate';

        /**
         * Save locally the user network
         * @param  {Object} userNetwork
         */
        function _saveLocally(userNetwork) {
            localStorageService.set(USER_NETWORK_KEY, JSON.stringify(userNetwork));
            localStorageService.set(
                USER_NETWORK_KEY_EXPIRATION,
                moment()
                    .add(1, 'days')
                    .format('YYYY-MM-DD')
            );
        }

        /**
         * Get the locally saved userNetwork
         * @return {Object}
         */
        function _getLocally() {
            var userNetwork = localStorageService.get(USER_NETWORK_KEY);
            var expirationDate = localStorageService.get(USER_NETWORK_KEY_EXPIRATION);

            expirationDate = expirationDate === '[]' ? null : expirationDate;
            userNetwork = userNetwork ? JSON.parse(userNetwork) : userNetwork;

            return {
                userNetwork: userNetwork,
                expirationDate: expirationDate
            };
        }

        /**
         * Get user network
         * If the user network exists locally and the expiration date is correct or if the app is offline, we do not perform an HTTP request
         * @return {Promise}
         */
        self.getUserNetwork = function getUserNetwork(uid) {
            var d = $q.defer();
            var userNetworkKeys = _getLocally();
            if (
                !$root.online ||
                (userNetworkKeys.userNetwork &&
                    userNetworkKeys.expirationDate &&
                    moment(userNetworkKeys.expirationDate).isSameOrAfter(moment().format('YYYY-MM-DD')))
            ) {
                $log.info('GET local user network');
                d.resolve(userNetworkKeys.userNetwork);
                return d.promise;
            }

            userNetworkProvider.getUserNetwork(uid).then(function(userNetwork) {
                _saveLocally(userNetwork);
                d.resolve(userNetwork);
            }, d.reject.bind(d));

            return d.promise;
        };

        self.clearCache = function clearCache() {
            localStorageService.set(USER_NETWORK_KEY, JSON.stringify([]));
            localStorageService.set(USER_NETWORK_KEY_EXPIRATION, JSON.stringify([]));
        };

        return self;
    }

    UserNetworkService.$inject = ['$rootScope', '$q', '$log', '$cookies', 'userNetwork', 'localStorageService'];

    angular.module('app.bdc.list.userNetworkService', []).factory('userNetworkService', UserNetworkService);
});
